import React, {
  CSSProperties,
  FormEvent,
  useEffect,
  useRef,
  useState,
} from "react"

import * as styles from "./NewsletterForm.module.css"
import { makeAbsoluteUrl } from "../../utility"
import { usePost } from "../../hooks/usePost"
import classNames from "classnames"
import CheckCircleOutlined from "../../assets/icons/CheckCircleOutlined.inline.svg"
import CloseCircleOutlined from "../../assets/icons/CloseCircleOutlined.inline.svg"
import SendOutlined from "../../assets/icons/SendOutlined.inline.svg"

export const EmailInput = ({
  radius,
  referred,
  hasNameInput = false,
  inputContainerClassName,
}: {
  radius: number
  referred: {
    name?: string
    section: string
    url: string
  }
  hasNameInput?: boolean
  inputContainerClassName?: string
}) => {
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [sendingNewsletterStatus, setSendingNewsletterStatus] = useState<
    "success" | "fail"
  >()
  const FormRef = useRef<HTMLFormElement>(null)

  const { data, loading, save, error } = usePost("NewsLetter")

  const sendNewsletter = React.useCallback(
    (e: FormEvent) => {
      e.preventDefault()

      if (FormRef.current?.checkValidity()) {
        const nameField = hasNameInput
          ? [{ name: "lastName", value: name }]
          : []

        save({
          fields: [
            {
              name: "email",
              value: email,
            },
            ...nameField,
          ],
          context: {
            pageUri: makeAbsoluteUrl(referred.url),
            pageName: referred?.name
              ? `${referred.section} | ` + referred.name
              : referred.section,
          },
        })
      }
      FormRef.current?.reportValidity()
    },
    [email]
  )

  useEffect(() => {
    if (!loading && (data || error)) {
      if (data && !error) {
        setEmail("")
        setName("")
        setSendingNewsletterStatus("success")
      }
      if (error && !data) {
        setSendingNewsletterStatus("fail")
      }
      setTimeout(() => {
        setSendingNewsletterStatus(undefined)
      }, 1000)
    }
  }, [error, data, loading])

  return (
    <form
      ref={FormRef}
      onSubmit={e => sendNewsletter(e)}
      className={classNames(
        styles.newsletter__input__container,
        inputContainerClassName
      )}
    >
      <div className={styles.newsletter__input__email}>
        <input
          value={email}
          style={{ ["--radius"]: `${radius}px` } as CSSProperties}
          onChange={e => setEmail(e.target.value)}
          className={styles.newsletter__input}
          placeholder="Enter your email"
          type="email"
          name="name"
          required
        />

        <button onClick={sendNewsletter} className={styles.newsletter__send}>
          {sendingNewsletterStatus === "success" ? (
            <CheckCircleOutlined />
          ) : sendingNewsletterStatus === "fail" ? (
            <CloseCircleOutlined />
          ) : (
            <SendOutlined spin={loading} />
          )}
        </button>
      </div>

      {hasNameInput && (
        <input
          value={name}
          style={{ ["--radius"]: `${radius}px` } as CSSProperties}
          onChange={e => setName(e.target.value)}
          className={styles.newsletter__input}
          placeholder="Enter your name"
          type="text"
          name="name"
          required
        />
      )}
    </form>
  )
}
